/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import Fade from 'react-awesome-reveal';

import NotFound from 'assets/images/NotFound.png';

import Button from 'elements/Button';

export default function PortfolioDetail({ data }) {
  if (data === null) {
    return (
      <section className="container mx-auto">
        <Fade bottom triggerOnce>
          <div className="flex flex-col w-full justify-center">
            <div className="flex w-full justify-center">
              <img src={NotFound} alt="Not Found" className="sm:w-3/4 xl:w-5/12 mt-5" />
            </div>
            <h1 className="text-theme-blue text-2xl text-center mt-5">
              Project Not Found
            </h1>
            <div className="flex justify-center">
              <Button href="/project" type="link" className="flex w-30 h-10 px-5 mt-5 bg-theme-blue text-white items-center rounded transform transition duration-500 hover:bg-gray-900">
                Go Back
              </Button>
            </div>
          </div>
        </Fade>
      </section>
    );
  }

  return (
    <section className="container mx-auto">
      <Fade bottom>
        <Button type="link" href="/project" className="flex w-40 h-8 text-lg items-center ml-6 sm:ml-20 mt-8 font-light text-gray-400 hover:underline">
          <svg className="w-5 h-5 text-gray-400 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
          See All Project
        </Button>
      </Fade>

      {
        data.map((item) => (
          <div className="flex flex-col mt-8 justify-center">
            <Fade bottom triggerOnce>
              <h1 className="text-5xl text-theme-blue text-center font-bold">{item.title}</h1>

              <p className="font-light text-xl text-gray-400 text-center mb-10">
                {item.type}
              </p>
            </Fade>

            <Fade bottom delay={300 * 1} triggerOnce>
              <div className="flex justify-center xl:mb-6">
                <div className="w-4/5 sm:w-4/6">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-72 sm:h-80 md:h-96 rounded-2xl object-cover"
                    onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = 'https://images.unsplash.com/photo-1520975922172-3d1c19b7b1d5?auto=format&fit=crop&w=1400&q=60'; }}
                  />
                </div>
              </div>
            </Fade>

            <Fade bottom delay={300 * 1} triggerOnce>
              <div className="flex flex-col mt-16 mb-12 mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-3">Project Detail</h1>
                <p className="font-light text-lg text-gray-400 text-justify">
                  {item.description || 'This project showcases our approach to delivering fast, reliable experiences with a modern UI and clean architecture.'}
                </p>
              </div>

              {Array.isArray(item.features) && item.features.length > 0 && (
                <div className="flex flex-col mx-8 sm:mx-16 xl:mx-28 mb-10">
                  <h2 className="text-2xl text-theme-blue font-bold mb-3">Key Features</h2>
                  <ul className="list-disc pl-6 text-gray-500">
                    {item.features.map((f) => (
                      <li className="mb-1">{f}</li>
                    ))}
                  </ul>
                </div>
              )}

              {Array.isArray(item.techStack) && item.techStack.length > 0 && (
                <div className="flex flex-col mx-8 sm:mx-16 xl:mx-28 mb-10">
                  <h2 className="text-2xl text-theme-blue font-bold mb-3">Tech Stack</h2>
                  <div className="flex flex-row flex-wrap">
                    {item.techStack.map((t) => (
                      <div className="mr-3 mb-3 px-4 py-2 text-theme-purple border border-theme-purple rounded-full shadow-sm">{t}</div>
                    ))}
                  </div>
                </div>
              )}

              <div className="flex flex-col mx-8 sm:mx-16 xl:mx-28">
                <h1 className="text-3xl text-theme-blue font-bold mb-5">Project Responsibilities</h1>
                <div className="flex flex-row ml-1 flex-wrap">
                  {item.responsibility.map((responsibility) => (
                    <div className="mr-4 mb-3 px-6 py-3 text-theme-purple border border-theme-purple rounded-full shadow-lg">{responsibility}</div>
                  ))}
                </div>
              </div>

              {item.credit && (
                <p className="font-light italic text-gray-400 mt-16 mx-8 sm:mx-16 xl:mx-28">
                  * This project is just example.
                  {' '}
                  <br />
                  Original project :
                  {' '}
                  <Button type="link" href={item.credit} target="_blank" className="text-theme-purple" isExternal>{item.credit}</Button>
                </p>
              )}
            </Fade>
          </div>
        ))
      }
    </section>
  );
}
